import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let mpnchecking = new BaseTableModule('/ws/mpnchecking/');

const state = {
    ...mpnchecking.state,
    columns: [
        // {text: 'Actions', value: 'actions', sortable: false, divider: true, brief: true,},
        {text: 'Search status', value: 'search_status', sortable: true, divider: true, brief: true,},
        {text: 'MPN', value: 'mpn', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Providers', value: 'available_providers', sortable: false, divider: true, brief: true,},
        {text: 'Correct status', value: 'correct_status', sortable: true, divider: true, brief: true,},
        {text: 'Version', value: 'version', sortable: false, divider: true, brief: true,},
        // {text: 'Edited by', value: 'edited_by__username', sortable: true, divider: true, brief: true,},
        // {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, brief: true,},
    ],
    briefView: true,
    options: {
        page: 1,
        itemsPerPage: 250,
        sortBy: ['-id'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: true,
    },

};
const getters = {
    ...mpnchecking.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true)
        } else {
            return state.columns
        }
    },
};
const actions = {
    ...mpnchecking.actions,
};
const mutations = {
    ...mpnchecking.mutations,
};

export default {
    modules: {
        MPNChecking: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}